import { render } from "./createInstructionForm.vue?vue&type=template&id=b735ad20&ts=true"
import script from "./createInstructionForm.vue?vue&type=script&lang=ts"
export * from "./createInstructionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__